import { Controller } from "stimulus"
import { showTarget, hideTarget } from '../helpers/visibility'

export default class extends Controller {
  static targets = [
    "authorizeCheckbox",
    "authorizeAmount",
    "previouslyAuthorizedAmount",
    "currentlyAuthorizedAmount", 
    "totalAuthorizedAmount",
    "authorizationData",
    "footer"
  ]

  connect() {
    this.syncData()
  }

  toggleCheckbox(e) {
    showTarget(this.footerTarget)

    const qbBillId = e.target.getAttribute("data-qb-bill-id")
    const qbLineNum = e.target.getAttribute("data-qb-line-num")

    const otherCheckboxes = this.authorizeCheckboxTargets
      .filter(checkbox => checkbox.getAttribute("data-qb-bill-id") == qbBillId)


    otherCheckboxes.forEach(checkbox => {
      checkbox.checked = e.target.checked
    })


    this.syncData()
  }

  syncData() {
    let currentlyAuthorizedTotal = 0
    let authorizationData = {}

    this.authorizeCheckboxTargets.forEach(checkboxTarget => {
      const qbBillId = checkboxTarget.getAttribute("data-qb-bill-id")
      const qbLineNum = checkboxTarget.getAttribute("data-qb-line-num")
      const qbBillAuthorizationId = checkboxTarget.getAttribute("data-qb-bill-authorization-id")

      const authorizeAmountTarget = this.authorizeAmountTargets
        .filter(amount => amount.getAttribute("data-qb-bill-id") == qbBillId)
        .find(amount => amount.getAttribute("data-qb-line-num") == qbLineNum)

      if(checkboxTarget.checked) {
        showTarget(authorizeAmountTarget)
        currentlyAuthorizedTotal += parseFloat(authorizeAmountTarget.value) || 0
        authorizationData[qbBillAuthorizationId] = {
          qbAuthorizationId: qbBillAuthorizationId,
          authorized: true,
          qbBillId: qbBillId,
          qbLineNum: qbLineNum,
          amount: authorizeAmountTarget.value
        }
      }
      else {
        hideTarget(authorizeAmountTarget)
        authorizationData[qbBillAuthorizationId] = {
          qbAuthorizationId: qbBillAuthorizationId,
          authorized: false,
          qbBillId: qbBillId,
          qbLineNum: qbLineNum,
        }
      }
    })
    
    // Calculate total authorized amount (previously + currently authorized)
    const previouslyAuthorizedAmount = parseFloat(this.element.dataset.previouslyAuthorized) || 0
    const totalAuthorizedAmount = previouslyAuthorizedAmount + currentlyAuthorizedTotal
    this.totalAuthorizedAmountTarget.innerText = `$${totalAuthorizedAmount.toFixed(2)}`
    
    // Show currently selected amount only if non-zero
    if (currentlyAuthorizedTotal > 0) {
      this.currentlyAuthorizedAmountTarget.innerText = `($${currentlyAuthorizedTotal.toFixed(2)} currently selected)`
    } else {
      this.currentlyAuthorizedAmountTarget.innerText = ``
    }
    
    this.authorizationDataTarget.value = JSON.stringify(authorizationData)
  }
}

